import React from "react";

interface ProgressBarProps {
  value: number;
  max: number;
  withText?: boolean;
  size: "small" | "medium" | "large";
}

const ProgressBar = ({ value, max = 100, withText = false, size = "medium" }: ProgressBarProps) => {
  let height;
  let status;

  switch (size) {
    case "small":
      height = "4px";
      break;
    case "medium":
      height = "8px";
      break;
    case "large":
      height = "12px";
      break;
    default:
      height = "8px";
  }

  if (value == max) {
    status = "success";
  } else {
    status = "error";
  }

  return (
    <div>
      <progress className={`si-progress si-progress-${status}`} value={value} max={max} style={{ height }} />
      {withText && <div className="BodyText--muted">{`${value} of ${max}`}</div>}
    </div>
  );
};

export default ProgressBar;
